import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

// Interface
interface OptionsMenuIconProps {
	sx?: object;
	title?: ReactNode;
	disabled?: boolean;
	iconClasses?: string;
	tooltipProps?: Partial<TooltipProps>;
	iconProps?: SvgIconProps;
}

// MUI
import { Box, SvgIcon, SvgIconProps, Tooltip, TooltipProps } from "@mui/material";

// Images
import { ReactComponent as IconExported } from "@/assets/icons/common/exported.svg";

export default function ExportedIcon(props: Readonly<OptionsMenuIconProps>) {
	const { iconClasses = "", title = "", iconProps = {}, tooltipProps = {}, sx = null } = props;

	return (
		<Tooltip title={title} arrow placement="top" {...tooltipProps}>
			<Box {...sx}>
				<SvgIcon
					inheritViewBox
					component={IconExported}
					{...iconProps}
					className={twMerge("[&_path]:fill-current text-default !w-[unset] !h-[unset]", iconClasses)}
				/>
			</Box>
		</Tooltip>
	);
}
